import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/marketplace',
    element: lazy(() => import('../pages/marketplace/page')),
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
